import React from 'react';
import { CellField, type DataTableColumn, SearchField } from '@/components/custom/erp';
import { loaiGiaBanSearchColumns } from '@/constants/search-columns';
import type { GiaBanDetailRow, LoaiGiaBan } from '@/types/schemas';
import QUERY_KEYS from '@/constants/query-keys';

export const getInputTableColumns = (
  onCellValueChange: (rowUuid: string, field: string, newValue: unknown) => void
): DataTableColumn<GiaBanDetailRow>[] => [
  {
    field: 'ma_loai_gb',
    headerName: 'Mã loại giá bán',
    width: 175,
    renderCell: params => {
      return (
        <SearchField<LoaiGiaBan>
          value={params.row.ma_loai_gb_data?.ma_loai_gb || ''}
          searchEndpoint={`/${QUERY_KEYS.LOAI_GIA_BAN}`}
          searchColumns={loaiGiaBanSearchColumns}
          dialogTitle='Danh mục loại giá bán'
          columnDisplay='ma_loai_gb'
          onRowSelection={(row: LoaiGiaBan) => {
            onCellValueChange(params.row.uuid, 'ma_loai_gb_data', row);
          }}
        />
      );
    }
  },
  {
    field: 'ten_loai_gb',
    headerName: 'Tên loại giá bán',
    width: 200,
    renderCell: params => <CellField name='ten_loai_gb' value={params.row.ma_loai_gb_data?.ten_loai_gb} />
  },
  {
    field: 'gia',
    headerName: 'Giá',
    width: 200,
    renderCell: params => (
      <CellField
        name='gia'
        type='number'
        value={params.row.gia}
        onValueChange={(newValue: unknown) => onCellValueChange(params.row.uuid, 'gia', newValue)}
      />
    )
  }
];
